<h3 class="race-percentage-title bold fund-allocation">Fund allocation per university</h3>
<div class="chart-container">
  <canvas #canvas id="universityCategoryChartId"> {{ universityCategoryChart }} </canvas>
</div>
